export interface FaqItem {
  question: string
  answer: string
}

export const faqs: FaqItem[] = [
  {
    question: 'How do I receive it? Is anything shipped?',
    answer:
      'Nothing is shipped. Yoga Teaching Vault™ is 100% digital, delivered in PDF format — after completing your purchase you receive access according to the digital delivery method shown at checkout.',
  },
  {
    question: 'Is this only for new yoga teachers?',
    answer:
      'No. New teachers may especially appreciate the structure, scripts and Confidence Kit, while experienced teachers use the Vault to reduce planning time, create more variety and have backup classes ready.',
  },
  {
    question: 'Do I have to teach the classes exactly as written?',
    answer:
      'No. The Vault gives you a ready-to-use starting structure. You remain the teacher and can adapt the material to your teaching context, training, students and professional scope.',
  },
  {
    question: 'What styles and levels are included?',
    answer:
      'Beginner & Gentle Yoga, Hatha, Slow Flow & Accessible Vinyasa, Mobility, Restorative/Yin-inspired/breath-based practices, Chair Yoga, mixed-level and adaptable classes — from ages and abilities across the whole room. Volume 01 focuses specifically on beginners.',
  },
  {
    question: 'What if I need a class at the last minute, or I’m substituting?',
    answer:
      'That’s exactly why 30 Emergency Ready-to-Teach Classes™ is included, alongside adaptable and no-prop options. The 60-Second Class Finder™ helps you identify the right class in under a minute.',
  },
  {
    question: 'Can I use the PDFs from my phone or tablet, and print them?',
    answer:
      'Yes. It’s designed as a digital PDF library you can reference from any device that supports PDFs, and you can print pages for your own personal teaching reference, subject to the license terms provided with the product.',
  },
  {
    question: 'Does this replace yoga teacher training or medical advice?',
    answer:
      'No. Yoga Teaching Vault™ is a planning and teaching resource. It does not replace professional yoga teacher education, qualifications, experience or judgment, and it is not a substitute for individualized medical advice, diagnosis or treatment.',
  },
]
